module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('router-view', {
    staticClass: "fiui-wrapper",
    attrs: {
      "keep-alive": "",
      "transition": "",
      "transition-mode": "out-in"
    }
  }), _vm._v(" "), (_vm.isTestEnv) ? _c('test-env') : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0d9db490"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/app.vue
// module id = 189
// module chunks = 0